import { render } from "./SignUpActivation.vue?vue&type=template&id=510b7c3e&scoped=true&ts=true"
import script from "./SignUpActivation.vue?vue&type=script&lang=ts"
export * from "./SignUpActivation.vue?vue&type=script&lang=ts"

import "./SignUpActivation.vue?vue&type=style&index=0&id=510b7c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510b7c3e"]])

export default __exports__